export const DEFAULT_ICON_WIDTH = '38px';
export const DEFAULT_ICON_HEIGHT = '2px';
